import { useTranslation } from '@portals-platform/i18n';
import { useFormContext, useWatch } from '@portals-platform/ui-forms';
import type { DynamicFieldKey, FormValues } from '../../../lib/new-certificate/types.js';
import { CertificateDynamicFields } from './certificate-dynamic-field.js';
import { CertificateSection } from './certificate-section.js';

export function CoverageLimitsSection({ fieldKeys }: { fieldKeys: DynamicFieldKey[] }) {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const currency = useWatch({ control, name: 'currency' });

  return (
    <CertificateSection
      title={t('certificates.new.sections.coverageLimits')}
      description={t('certificates.new.coverage.amountsIn', { currency: currency || 'USD' })}
    >
      <CertificateDynamicFields fieldKeys={fieldKeys} />
    </CertificateSection>
  );
}
